"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array-buffer.constructor.js");
require("core-js/modules/es.array-buffer.slice.js");
require("core-js/modules/es.array-buffer.detached.js");
require("core-js/modules/es.array-buffer.transfer.js");
require("core-js/modules/es.array-buffer.transfer-to-fixed-length.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.typed-array.uint8-array.js");
require("core-js/modules/es.typed-array.at.js");
require("core-js/modules/es.typed-array.copy-within.js");
require("core-js/modules/es.typed-array.every.js");
require("core-js/modules/es.typed-array.fill.js");
require("core-js/modules/es.typed-array.filter.js");
require("core-js/modules/es.typed-array.find.js");
require("core-js/modules/es.typed-array.find-index.js");
require("core-js/modules/es.typed-array.find-last.js");
require("core-js/modules/es.typed-array.find-last-index.js");
require("core-js/modules/es.typed-array.for-each.js");
require("core-js/modules/es.typed-array.includes.js");
require("core-js/modules/es.typed-array.index-of.js");
require("core-js/modules/es.typed-array.iterator.js");
require("core-js/modules/es.typed-array.join.js");
require("core-js/modules/es.typed-array.last-index-of.js");
require("core-js/modules/es.typed-array.map.js");
require("core-js/modules/es.typed-array.reduce.js");
require("core-js/modules/es.typed-array.reduce-right.js");
require("core-js/modules/es.typed-array.reverse.js");
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.slice.js");
require("core-js/modules/es.typed-array.some.js");
require("core-js/modules/es.typed-array.sort.js");
require("core-js/modules/es.typed-array.subarray.js");
require("core-js/modules/es.typed-array.to-locale-string.js");
require("core-js/modules/es.typed-array.to-reversed.js");
require("core-js/modules/es.typed-array.to-sorted.js");
require("core-js/modules/es.typed-array.to-string.js");
require("core-js/modules/es.typed-array.with.js");
require("core-js/modules/es.uint8-array.set-from-base64.js");
require("core-js/modules/es.uint8-array.set-from-hex.js");
require("core-js/modules/es.uint8-array.to-base64.js");
require("core-js/modules/es.uint8-array.to-hex.js");
require("core-js/modules/web.atob.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.dom-exception.constructor.js");
require("core-js/modules/web.dom-exception.stack.js");
require("core-js/modules/web.dom-exception.to-string-tag.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url.to-json.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _auth = require("@/utils/auth");
var _printtemplateconfig = require("../../api/jmreport/printtemplateconfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { exportPdf } from '../../api/jmreport/jimureport'
var _default2 = exports.default = {
  name: 'JmPrint',
  data: function data() {
    return {
      pLrintUrl: require('@/settings.js').jmPrintUrl + '/jmreport/view/',
      // 打印页面
      showDialog: false,
      jmReportId: '',
      // 积木设计报表ID
      printTemplateList: [],
      // 打印模板
      printLoading: false
    };
  },
  // 父页面传递的属性定义
  props: {
    visiblePrintTemplate: {
      // 是否显示选择打印模板页面
      type: Boolean,
      default: true
    },
    menuCode: {
      // 菜单编码
      type: String,
      require: true,
      default: ''
    },
    queryParam: {
      // 参数对象，在数据源页面配置的参数，比如：{"billCode":billCode,"pageSize":"100"}
      type: Object,
      require: false,
      default: function _default() {
        return {};
      }
    },
    queryPathParam: {
      // 请求地址，比如 billCode='12345'&id=1111
      type: String,
      require: false,
      default: ''
    },
    model: {
      // 打印类型
      type: String,
      require: false,
      default: 'pdf' // pdf-PDF打印，适合单条打印；browser-浏览器打印，支持多条数据打印
    },
    titleDesc: {
      // 对话框名称
      type: String,
      default: '选择打印模板'
    },
    writePrintStatus: {
      type: Function,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {},
  watch: {
    visiblePrintTemplate: function visiblePrintTemplate(newVal, oldVal) {
      this.showDialog = newVal;
    }
  },
  created: function created() {
    var _this = this;
    // 查找菜单对应的打印模板
    (0, _printtemplateconfig.getByMenuCode)({
      menuCode: this.menuCode
    }).then(function (resp) {
      _this.printTemplateList = resp.data != null ? resp.data.entryList : [];
    });
  },
  methods: {
    // 打印链接
    doPrint: function doPrint() {
      this.printLoading = true;
      this.writePrintStatus();
      if (this.model === 'pdf') {
        this.pdfPrint();
      } else if (this.model === 'browser') {
        this.browserPrint();
      }
    },
    // pdf打印
    pdfPrint: function pdfPrint() {
      var _this2 = this;
      var params = {};
      params.excelConfigId = this.jmReportId;
      // 参数对象，在数据源页面配置的参数，接受数组为queryParam
      params.queryParam = this.queryParam;
      var headers = {};
      headers.token = (0, _auth.getToken)();
      headers['Content-Type'] = 'application/json;charset=utf-8';
      exportPdf(params, headers).then(function (res) {
        // 成功
        if (res.success) {
          // 获取base64文件
          var file = res.result.file;
          var bstr = atob(file);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var blob = new Blob([u8arr], {
            type: 'application/pdf;chartset=UTF-8'
          });
          // 创建url
          var fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
        }
      }).catch(function () {}).finally(function () {
        // 关闭选择模板对话框
        _this2.closePrintTemplateDialog();
        _this2.$refs.grid.handleQuery();
      });
    },
    // 浏览器打印
    browserPrint: function browserPrint() {
      var printUrlNew = this.printUrl + this.jmReportId + '?token=' + (0, _auth.getToken)() + '&' + this.queryPathParam;
      window.open(printUrlNew, '_blank');
      this.closePrintTemplateDialog();
    },
    // dialog  关闭
    closePrintTemplateDialog: function closePrintTemplateDialog() {
      this.printLoading = false;
      this.jmReportId = '';
      this.showDialog = false;
      this.$emit('update:visiblePrintTemplate', false);
    }
  }
};